import { useForm } from "react-hook-form";
import { Button, Stack, Card, Title, Group, Divider } from "@mantine/core";

import resolver from "@congrs/resolver";
import { useCreateRegistrationTicketType } from "../../api/registrationTicketTypes";
import { web_createRegistrationTicketTypeSchema } from "@congrs/schemas";
import { makeI18nDefaultValue } from "../../utils/i18nUtils";
import LocalizedInput from "../common/LocalizedInput";
import { TextInput, Textarea } from "react-hook-form-mantine";

function CreateRegistrationTicketType({ event }) {
  const createTicketType = useCreateRegistrationTicketType();

  const mainLanguage = event?.language || "en";
  const otherLanguages = event?.secondaryLanguages || [];

  const {
    control,
    handleSubmit,
    formState: { isDirty, errors },
    reset,
  } = useForm({
    defaultValues: {
      eventId: event.id,
      nameI18n: makeI18nDefaultValue(mainLanguage, otherLanguages),
      descriptionI18n: makeI18nDefaultValue(mainLanguage, otherLanguages),
      price: "",
    },
    resolver: resolver(web_createRegistrationTicketTypeSchema),
  });

  const onSubmit = (values) => {
    createTicketType.mutate(values, {
      onSuccess: () =>
        reset({
          eventId: event.id,
          nameI18n: makeI18nDefaultValue(mainLanguage, otherLanguages),
          descriptionI18n: makeI18nDefaultValue(mainLanguage, otherLanguages),
          price: "",
        }),
    });
  };

  const localizedInputFields = [
    {
      nameBase: "nameI18n",
      label: "Name",
      component: TextInput,
      props: {
        size: "sm",
        placeholder: "Ticket name",
        withAsterisk: true,
      },
    },
    {
      nameBase: "descriptionI18n",
      label: "Description",
      component: Textarea,
      props: {
        autosize: true,
        minRows: 4,
        size: "sm",
        placeholder: "Optional description",
      },
    },
  ];

  return (
    <Card
      shadow="sm"
      p="lg"
      radius="md"
      mt="sm"
      withBorder
      style={{ maxWidth: 600 }}
    >
      <Title order={3}>Create Ticket Type</Title>
      <Divider my="md" />

      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack gap="md">
          <LocalizedInput
            control={control}
            fields={localizedInputFields}
            mainLanguage={mainLanguage}
            otherLanguages={otherLanguages}
          />

          <TextInput
            control={control}
            name="price"
            label="Price"
            placeholder="e.g. 49.99"
            error={errors.price?.message}
          />

          <Group justify="flex-end" mt="md">
            <Button
              type="submit"
              loading={createTicketType.isPending}
              disabled={!isDirty}
            >
              Create
            </Button>
          </Group>
        </Stack>
      </form>
    </Card>
  );
}

export default CreateRegistrationTicketType;
